import { jwtDecode } from 'jwt-decode'
import { createContext, useCallback, useState } from 'react'
import { useCookies } from 'react-cookie'

export type Auth = ReturnType<typeof useAuth>
export const AuthContext = createContext<Auth>({
  accessToken: null,
  clientId: -1,
  setAccessToken: async () => {},
  clearTokens: async () => {},
  isLogged: false,
})

type AccessToken = {
  sub: string
  exp: string
  'https://homelab24.com/jwt/claims': {
    'x-hasura-client-id': string
  }
}

export function useAuth() {
  const [accessToken, setAccessToken] = useState<string | null>(null)
  const [, , removeRefreshToken] = useCookies(['clientAppRefreshToken'])

  return {
    accessToken,
    get clientId() {
      if (this.accessToken) {
        const payload = jwtDecode<AccessToken>(this.accessToken)
        return parseInt(
          payload['https://homelab24.com/jwt/claims']['x-hasura-client-id']
        )
      }

      return -1
    },
    setAccessToken,
    clearTokens: useCallback(async () => {
      setAccessToken(null)
      removeRefreshToken('clientAppRefreshToken')
    }, [setAccessToken, removeRefreshToken]),
    isLogged: !!accessToken,
  }
}

export function isTokenExpired(accessToken: string, offset = 0) {
  const payload = jwtDecode<AccessToken>(accessToken)
  return Date.now() >= parseInt(payload.exp) * 1000 + offset
}
